import log from 'loglevel'
import axios from 'axios'
import Cache from '../../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class CommitmentItem {
  constructor() {
    log.info('[INFO] Initialize Commitment Item Module')
    this.cache = new Cache()
  }

  fetchAllCommitmentItem(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/order/commitment/item/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch commitment item')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch commitments')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchCommitmentItem(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/order/commitment/item/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch commitment item')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch commitment item')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateCommitmentItem(id, commitmentData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/order/commitment/item/${id}/`, commitmentData)
        .then(response => {
          log.debug('[DEBUG] Success to update commitment item')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update commitment item')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addCommitmentItem(commitmentData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/order/commitment/item/', commitmentData)
        .then(response => {
          log.debug('[DEBUG] Success to add commitment item')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add commitment item')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteCommitmentItem(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/order/commitment/item/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete commitment item')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete commitment item')
          log.error(error)
          reject(error.response)
        })
    })
  }

  fetchItemsToCommitment(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/order/items/to/commitment/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch items to commitment')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch items to commitment')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateCommitmentItemProduct(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/order/commitment/item/product/${id}/`, data)
        .then(response => {
          log.debug('[DEBUG] Success to update commitment item product')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update commitment item product')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
